import PublicLayout from '../PublicLayout';

const DocumentLayout = () => (
  <PublicLayout
    surface="document"
    footerVariant="compact"
    showFooterCta={false}
  />
);

export default DocumentLayout;
